import { useEffect, useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { addPaymentMethod } from "../../actions/schoolsActions";
import Swal from "sweetalert2";
import { useTranslation } from "react-i18next";
import useAuth from "../../context/auth/useAuth";

export default function AddPaymentMethod({hideSubmitBtn = false, innerRef = null}) {
    
    const dispatch = useDispatch()
    const { t } = useTranslation()
	const {client} = useAuth()

    const {resultPaymentMethod, errorPaymentMethod} = useSelector(state=>state.schools)

    
    const [paymentMethodFormState, setPaymentMethodFormState] = useState({})

    const handlePaymentMethodInputChange = ({target}) => {
        setPaymentMethodFormState({
            ...paymentMethodFormState,
            [target.name]: target.value
        })
    }

    const handlePaymentMethodNumberChange = ({target}) => {
        setPaymentMethodFormState({
            ...paymentMethodFormState,
            [target.name]: target.value.replace(/[^\dA-Z]/g, '').replace(/(.{4})/g, '$1 ').trim()
        })
    }

    const handleAddPaymentMethod = async(e) => {
        e.preventDefault()
        if (paymentMethodFormState.name && paymentMethodFormState.name !== '' && paymentMethodFormState.number && paymentMethodFormState.number !== '' && paymentMethodFormState.cvc && paymentMethodFormState.cvc !== '' && paymentMethodFormState.month && paymentMethodFormState.month !== '' && paymentMethodFormState.year && paymentMethodFormState.year !== '') {
            dispatch(addPaymentMethod({id: client?.id, name: paymentMethodFormState.name, number: paymentMethodFormState.number, cvc: paymentMethodFormState.cvc, exp_month: paymentMethodFormState.month, exp_year: paymentMethodFormState.year}))
        } else {
            Swal.fire({
                showConfirmButton: true,
                icon: 'warning',
                text: t('users.pleasecomplete')
            })
        }
    }

    useEffect(() => {
        if (resultPaymentMethod && resultPaymentMethod === 'success') {
            switch (resultPaymentMethod) {
                case 'success':
                    setPaymentMethodFormState({
                        name: null,
                        number: null,
                        cvc: null,
                        month: null,
                        year: null
                    })
                    break;
                default:
                    break;
            }
            dispatch({type: 'SCHOOL_ADD_PAYMENTMETHODS_RESET'})
        }
    }, [resultPaymentMethod, dispatch])


    return (
        <Form onSubmit={handleAddPaymentMethod}>
            <Modal.Body>
                <Row>
                    <Col xs={12} className='mb-5'>
                        <Form.Label>{t('config.school.paymentMethod.name')}</Form.Label>
                        <Form.Control required autoComplete='off' name='name' onChange={handlePaymentMethodInputChange} value={paymentMethodFormState.name|| ''}/>
                    </Col>
                    <Col xs={12} md={6} className='mb-5'>
                        <Form.Label>{t('config.school.paymentMethod.number')}</Form.Label>
                        <Form.Control required autoComplete='off' name='number' maxLength={19} pattern='[0-9][0-9][0-9][0-9]\s[0-9][0-9][0-9][0-9]\s[0-9][0-9][0-9][0-9]\s[0-9][0-9][0-9][0-9]' onChange={handlePaymentMethodNumberChange} value={paymentMethodFormState.number || ''}/>
                    </Col>
                    <Col xs={12} md={6} className='mb-5'>
                        <Form.Label>{t('config.school.paymentMethod.cvc')}</Form.Label>
                        <Form.Control required autoComplete='off' name='cvc' maxLength={3} pattern='[0-9]{3}' onChange={handlePaymentMethodInputChange} value={paymentMethodFormState.cvc || ''}/>
                    </Col>
                    <Col xs={12} md={6} className='mb-5'>
                        <Form.Label>{t('config.school.paymentMethod.month')}</Form.Label>
                        <Form.Control required autoComplete='off' name='month' maxLength={2} onChange={handlePaymentMethodInputChange} value={paymentMethodFormState.month || ''}/>
                    </Col>
                    <Col xs={12} md={6} className='mb-5'>
                        <Form.Label>{t('config.school.paymentMethod.year')}</Form.Label>
                        <Form.Control required autoComplete='off' name='year' maxLength={2} onChange={handlePaymentMethodInputChange} value={paymentMethodFormState.year || ''}/>
                    </Col>
                    {
                        errorPaymentMethod &&
                            <Col className='text-danger'>
                                <span>{t('school.errorPaymentMethod')}</span>
                            </Col>
                    }
                </Row>
            </Modal.Body>
            <Modal.Footer className={`${hideSubmitBtn ? 'd-none' : ''}`}>
                <Button type='submit' variant='primary' ref={innerRef}>{t('global.add')}</Button>
            </Modal.Footer>
        </Form>
    )
}